import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import axios from 'axios';
import db from '../dbconn';
import {API_ROOT} from './../api-config';
import Modal from 'react-responsive-modal';
import moment from 'moment';
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';
import Swal from 'sweetalert2';

class sign_up extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            open: false,
            windowHeight: 0,
            fb_id: 0,
            selectedCountry: 'Select Any',
            swalButton: '',
            orderTypeDialog: '',
            years: "",
            phone: '',
            selectedMonth: "Month",
            selectedDate: "Day",
            selectedYear: "Year",

        };
        const year = (new Date()).getFullYear() - 13;
        this.years = Array.from(new Array(100), (val, index) => year - index);
    };


    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };


    handleChange = e => {

        this.setState({phone: this.normalizeInput($(e.target).val(), this.state.phone)});
    };

    normalizeInput = (value, previousValue) => {
        if (!value) return value;
        var currentValue = value.replace(/[^\d]/g, '');
        var cvLength = currentValue.length;

        if (!previousValue || value.length > previousValue.length) {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };

    componentWillMount() {
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
    }

    componentDidMount() {

        document.title = "Sign Up - " + localStorage.getItem("store_name") + " - Tria Commerce";


        const params = new URLSearchParams(this.props.location.search);

        console.log("TSET " + params);


        if (params != "") {
            sessionStorage.setItem('new_email', params.get('email'));
            sessionStorage.setItem('new_name', params.get('name'));
            sessionStorage.setItem('new_fb_id', params.get('id'));
        }


        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});

        if (sessionStorage.getItem('new_name') != null) {
            var fb_name = sessionStorage.getItem('new_name').split(' ');
            $('#custFirstNameTxt').val(fb_name[0]);
            $('#custLastNameTxt').val(fb_name[1]);
        }
        var fb_email = sessionStorage.getItem('new_email');

        if (fb_email != null) {
            $('#custEmailTxt').val(fb_email);
        }

        if (sessionStorage.getItem('new_fb_id') != null) {
            this.setState({fb_id: sessionStorage.getItem('new_fb_id')});
        }

        $('#signUpBtn').click(e => {

            var allGood = true;
            var cust_firstname = $('#custFirstNameTxt').val();
            var cust_lastname = $('#custLastNameTxt').val();
            var cust_email = $('#custEmailTxt').val();
            var cust_phone = $('#custPhoneTxt').val();
            var cust_Address = $('#custAddressTxt').val();
            var cust_city = $('#custCityTxt').val();
            var cust_state = $('#custStateTxt :selected').val();
            var cust_zip = $('#custZipTxt').val();
            var cust_username = ""/*"$('#custUsernameTxt').val()"*/;
            var cust_pwd = $('#custPassTxt').val();
            var cust_confirm_pwd = $('#custConfirmPassTxt').val();

            if (cust_firstname == '' ||
                cust_firstname == null ||
                cust_lastname == '' ||
                cust_lastname == null ||
                cust_email == '' ||
                cust_email == null ||
                cust_phone == '' ||
                cust_phone == null ||
                cust_Address == '' ||
                cust_Address == null ||
                cust_city == '' ||
                cust_city == null ||
                cust_state == '' ||
                cust_state == null ||
                cust_zip == '' ||
                cust_zip == null ||
                /*   cust_username == '' ||
                   cust_username == null ||*/
                cust_pwd == '' ||
                cust_confirm_pwd == '' ||
                cust_confirm_pwd == null ||
                cust_pwd == null) {

                allGood = false;

                this.state.swalButton.fire({
                    title: i18n.t('field_validation'),
                    allowOutsideClick: false
                });

            }
            if (!$('#termsChkBox').is(':checked')) {
                allGood = false;

                this.state.swalButton.fire({title: i18n.t('terms_and_conditions'), allowOutsideClick: false});

            }


            if (cust_pwd.length < 8) {
                allGood = false;
                this.state.swalButton.fire({
                    title: i18n.t('password_inst'),
                    allowOutsideClick: false
                });

            }

            if (cust_pwd !== cust_confirm_pwd) {
                allGood = false;
                this.state.swalButton.fire({
                    title: i18n.t('confirm_password_validation'),
                    allowOutsideClick: false
                });

            }


            if (!moment($('#customerYear').val() + "-" + $('#customerMonth').val() + "-" + $('#customerDate').val(), 'YYYY-MM-DD', true).isValid()) {
                allGood = false;
                this.state.swalButton.fire({
                    title: i18n.t('birth_validation'),
                    allowOutsideClick: false
                });
            }


            var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

            if (!pattern.test(cust_email)) {
                allGood = false;
                this.state.swalButton.fire({title: i18n.t('email_validation'), allowOutsideClick: false});

            }


            if (allGood) {
                this.onOpenModal();
                axios.post(API_ROOT + '/signup', {
                    customer_firstname: cust_firstname,
                    customer_lastname: cust_lastname,
                    customer_email: cust_email,
                    customer_phone: cust_phone,
                    customer_address: cust_Address,
                    customer_city: cust_city,
                    customer_state: cust_state,
                    customer_zip: cust_zip,
                    customer_username: cust_username,
                    customer_password: cust_pwd,
                    customer_marketing_optin: $('#marketingChkBox').is(":checked") ? "Y" : "N",
                    customer_dob: $('#customerYear').val() + "-" + $('#customerMonth').val() + "-" + $('#customerDate').val(),
                    store_id: localStorage.getItem("store_id"),
                    merchant_id: localStorage.getItem("merchant_id"),
                    customer_fb_id: this.state.fb_id
                })
                    .then(response => {

                        this.onCloseModal();

                        if (response.data.status == 1) {


                            this.state.swalButton.fire({
                                title: i18n.t('account_success'),
                                allowOutsideClick: false
                            }).then((result) => {
                                if (result.value) {
                                    var dbconn = new db();
                                    var data = response.data.customer_data[0];

                                    sessionStorage.setItem("guestFlag", "N");
                                    dbconn.set({
                                        customer_id: data.customer_id,
                                        customer_token: data.userToken,
                                        customer_firstname: data.customer_firstname,
                                        customer_lastname: data.customer_lastname,
                                        customer_email: data.customer_email,
                                        customer_address: data.customer_address,
                                        customer_city: data.customer_city,
                                        customer_state: data.customer_state,
                                        customer_zipcode: data.customer_zipcode,
                                        customer_phone: data.customer_phone,
                                        customer_fb_id: this.state.fb_id
                                    });

                                    this.setState({redirect: true});
                                }
                            });


                        } else {

                            if (response.data.message == "Phone Number already exists, please register with a different phone number.") {

                                this.state.swalButton.fire({
                                    title: i18n.t('phone_exists'),
                                    allowOutsideClick: false
                                });
                            } else if (response.data.message == "Email already exists, please register with a different email.") {
                                this.state.swalButton.fire({
                                    title: i18n.t('email_exists'),
                                    allowOutsideClick: false
                                });

                            } else {
                                this.state.swalButton.fire({
                                    title: response.data.message,
                                    allowOutsideClick: false
                                });
                            }

                        }
                    }).catch(error => {
                    this.onCloseModal();
                    console.log(error);
                });
            }

        });

    }

    updateCountryLabel = (e) => {
        var selectedOption = $(e.target).find('option:selected').text();
        $(e.target).next(".holder").text(selectedOption);
        this.setState({selectedCountry: selectedOption});
    };

    updateDOBMonth = (e) => {
        var selectedOption = $(e.target).find('option:selected').text();
        $(e.target).next(".holder").text(selectedOption);
        this.setState({selectedMonth: selectedOption});
    };

    updateDOBDate = (e) => {
        var selectedOption = $(e.target).find('option:selected').text();
        $(e.target).next(".holder").text(selectedOption);
        this.setState({selectedDate: selectedOption});
    };
    updateDOBYear = (e) => {
        var selectedOption = $(e.target).find('option:selected').text();
        $(e.target).next(".holder").text(selectedOption);
        this.setState({selectedYear: selectedOption});
    };

    render() {

        const {open} = this.state;
        const {t} = this.props;
        if (this.state.redirect) {
            return <Redirect to='/menu'/>;
        }


        return (

            <div>
                <header className="fixedHeader">
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to="/login"></Link>
                        <h2 className="text-center"><strong>{t('signup')}</strong></h2>
                    </div>
                </header>
                <div className="mt-white checkout h-100 "
                     style={{position: "fixed", width: "100%", height: "100vh", overflowY: "scroll"}}>
                    <div className="simple-box m-b-0 bp-0 p-b-35 bkg-white middleContent"
                         style={{padding: "0px", paddingBottom: "150px"}}>
                        <div className="form-box w-75 div-center">
                            <div className="header-title">
                                <h2 className="text-center font-size-20 m-0">{t('create_new_account')}</h2>
                                <div className="border-bottom"></div>
                            </div>

                            <div className="form-group">
                                <label>{t('first_name')}*</label>
                                <input type="text" className="form-control" name="custFirstNameTxt"
                                       id="custFirstNameTxt"/>
                            </div>
                            <div className="form-group">
                                <label>{t('last_name')}</label>
                                <input type="text" className="form-control" name="custLastNameTxt"
                                       id="custLastNameTxt"/>
                            </div>
                            <div className="form-group m_b_10">
                                <label>{t('email_address')}*</label>
                                <input type="text" className="form-control m-b-0" name="custEmailTxt" id="custEmailTxt"
                                />
                                <small>{t('we_never_share_your_email')}</small>
                            </div>
                            <div className="form-group m_b_10">
                                <label>{t('phone_number')}*</label>
                                <input type="text" className="form-control m-b-0" name="custPhoneTxt" id="custPhoneTxt"

                                       value={this.state.phone || ''}
                                       onChange={this.handleChange} required/>
                                <small>{t('phone_disclaimer')}</small>
                            </div>
                            <div className="form-group m_b_10">
                                <label>{t('address')}*</label>
                                <input type="text" className="form-control m-b-0" name="custAddressTxt"
                                       id="custAddressTxt"/>
                            </div>
                            <div className="form-group third-5-column">
                                <label>{t('city')}</label>
                                <input type="text" className="form-control" name="custCityTxt" id="custCityTxt"
                                       required/>
                            </div>
                            <div className="form-group  third-3-column">
                                <label>{t('state')}</label>

                                <select className="form-control custom-select radius-0 " id="custStateTxt"
                                        name="custStateTxt"
                                        required>

                                    <option value="">{t('select_any')}</option>
                                    <option value="AL">Alabama</option>
                                    <option value="AK">Alaska</option>
                                    <option value="AZ">Arizona</option>
                                    <option value="AR">Arkansas</option>
                                    <option value="CA">California</option>
                                    <option value="CO">Colorado</option>
                                    <option value="CT">Connecticut</option>
                                    <option value="DE">Delaware</option>
                                    <option value="DC">District Of Columbia</option>
                                    <option value="FL">Florida</option>
                                    <option value="GA">Georgia</option>
                                    <option value="HI">Hawaii</option>
                                    <option value="ID">Idaho</option>
                                    <option value="IL">Illinois</option>
                                    <option value="IN">Indiana</option>
                                    <option value="IA">Iowa</option>
                                    <option value="KS">Kansas</option>
                                    <option value="KY">Kentucky</option>
                                    <option value="LA">Louisiana</option>
                                    <option value="ME">Maine</option>
                                    <option value="MD">Maryland</option>
                                    <option value="MA">Massachusetts</option>
                                    <option value="MI">Michigan</option>
                                    <option value="MN">Minnesota</option>
                                    <option value="MS">Mississippi</option>
                                    <option value="MO">Missouri</option>
                                    <option value="MT">Montana</option>
                                    <option value="NE">Nebraska</option>
                                    <option value="NV">Nevada</option>
                                    <option value="NH">New Hampshire</option>
                                    <option value="NJ">New Jersey</option>
                                    <option value="NM">New Mexico</option>
                                    <option value="NY">New York</option>
                                    <option value="NC">North Carolina</option>
                                    <option value="ND">North Dakota</option>
                                    <option value="OH">Ohio</option>
                                    <option value="OK">Oklahoma</option>
                                    <option value="OR">Oregon</option>
                                    <option value="PA">Pennsylvania</option>
                                    <option value="RI">Rhode Island</option>
                                    <option value="SC">South Carolina</option>
                                    <option value="SD">South Dakota</option>
                                    <option value="TN">Tennessee</option>
                                    <option value="TX">Texas</option>
                                    <option value="UT">Utah</option>
                                    <option value="VT">Vermont</option>
                                    <option value="VA">Virginia</option>
                                    <option value="WA">Washington</option>
                                    <option value="WV">West Virginia</option>
                                    <option value="WI">Wisconsin</option>
                                    <option value="WY">Wyoming</option>
                                </select>


                            </div>
                            <div className="form-group third-4-column">
                                <label>{t('zip_code')}</label>
                                <input type="text" className="form-control" name="custZipTxt" id="custZipTxt"/>
                            </div>
                            <div className="form-group m_b_10">
                                <label>{t('password')}*</label>
                                <input type="password" className="form-control m-b-0" name="custPassTxt"
                                       id="custPassTxt"
                                       minLength="6"/>
                                {/* <span toggle="#password-field" className="toggle-password"><img
                                    src="img/view-icon.png"/></span>*/}
                                <small>{t('password_inst')}</small>
                            </div>
                            <div className="form-group m_b_10">
                                <label>{t('confirm_password')}*</label>
                                <input type="password" className="form-control" name="custConfirmPassTxt"
                                       id="custConfirmPassTxt"
                                       minLength="6"/>
                            </div>
                            <div className="form-group">
                                <label className="ch_box"><small>{t('signup_check')}</small>
                                    <input type="checkbox" id="marketingChkBox" name="marketingChkBox"/>
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <hr className="m_b_15"/>
                            <div className="form-group">
                                <label className="w-100">{t('date_of_birth')}*</label>
                                <div className="third-5-column">
                                    <select className="form-control custom-select radius-0" id="customerMonth"
                                            name="customerMonth">
                                        <option value="">{t('month')}</option>

                                        <option value="01">January</option>
                                        <option value="02">Febuary</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                </div>
                                <div className="third-3-column">
                                    <select className="form-control custom-select radius-0" id="customerDate"
                                            name="customerDate">
                                        <option>{t('day')}</option>
                                        <option value="01">1</option>
                                        <option value="02">2</option>
                                        <option value="03">3</option>
                                        <option value="04">4</option>
                                        <option value="05">5</option>
                                        <option value="06">6</option>
                                        <option value="07">7</option>
                                        <option value="08">8</option>
                                        <option value="09">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>
                                        <option value="21">21</option>
                                        <option value="22">22</option>
                                        <option value="23">23</option>
                                        <option value="24">24</option>
                                        <option value="25">25</option>
                                        <option value="26">26</option>
                                        <option value="27">27</option>
                                        <option value="28">28</option>
                                        <option value="29">29</option>
                                        <option value="30">30</option>
                                        <option value="31">31</option>
                                    </select>
                                </div>
                                <div className="third-4-column">
                                    <select className="form-control custom-select radius-0" id="customerYear"
                                            name="customerYear">
                                        <option value="">{t('year')}</option>
                                        {

                                            this.years.map((year, index) => {
                                                return <option key={`year${index}`} value={year}>{year}</option>
                                            })
                                        }

                                    </select>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                            <br/>
                            <div className="form-group">
                                <label className="ch_box"><small>{t('age_disclaimer')} <Link to={'/terms'}
                                                                                             className="underline">{t('terms_link')}</Link>.
                                </small>
                                    <input type="checkbox" id="termsChkBox" name="termsChkBox"/>
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                            <div className="form-group m-t-30 btn-red m-b-30">
                                <input type="submit" name="signUpBtn" id="signUpBtn" value={t('signup')}/>
                            </div>

                        </div>
                    </div>
                </div>


                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('signing')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
                <div className="clearfix"></div>
            </div>
        );
    }
}

export default withRouter(withTranslation()(sign_up));


// WEBPACK FOOTER //
// ./src/view_components/sign_up.js